import { Component, inject, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { IFooter, IFooterNode } from '../../models/footer.models';
import { skipWhile } from 'rxjs';
import { FooterFacade } from '../../facades/footer.facade';

@Component({
  selector: 'app-social-media-footer',
  templateUrl: './social-media-footer.component.html',
  styleUrls: ['./social-media-footer.component.scss'],
  standalone: false,
})
export class SocialMediaFooterComponent implements OnInit {

  content!: IFooter;
  links: IFooterNode[] = [];
  nodes: IFooterNode[] = [];

  private readonly footerFacade: FooterFacade = inject(FooterFacade);

  ngOnInit(): void {
    this.getSocialMediaFooter();
  }

  /**
   * Check if node has the css class as an icon
   * @param {string} cssClass
   * @returns {boolean}
   */
  isIcon(cssClass: string): boolean {
    return (cssClass ?? '').includes('icon');
  }

  /**
   * Get the social media footer
   */
  getSocialMediaFooter(): void {
    this.footerFacade.selectSocialMediaFooter().pipe(
      skipWhile(footer => !footer),
      take(1),
    ).subscribe(footer => {
      if (!footer) {
        return;
      }
      this.links = footer.data.attributes.nodes.filter(node => node.isActive);
    });
  }
}
